import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  page: string | null;
  month: string;
  perPage?: string | null;
};

const requestReportBirthdaysPDF = async ({ page, month, perPage }: Props) => {
  const response = await httpRequest.get(`/export-patients-birthdays-in-pdf?month=${month}&page=${page || 1}&per_page=${perPage || 10}`, {
    responseType: "blob",
  });
  return response.data;
};

export function useRequestReportBirthdaysPDFMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestReportBirthdaysPDF,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["report-birthdays-request-pdf"] });
    },
  });
}
